angular.module('app.resources', ['ngResource'])
  .factory('APIEventdata',    ['$resource', ($resource) -> $resource "api.php?path=/exhibitor_data.json", {_private: true, role: 'presenter'}])

  .factory('APIExhibitors',   ['$resource', ($resource) -> $resource "api.php?path=/exhibitors/:id", {id: '@id'}])
  .factory('APICheckin',      ['$resource', ($resource) -> $resource "api.php?path=/tickets/:shortcode/:action", {action: '@action'}])
  .factory('APIInquiries',    ['$resource', ($resource) -> $resource "api.php?path=/inquiries.json"])
  
  .factory('APIVisitor',      ['$resource', ($resource) -> $resource "api.php?path=/visitors.json", {_visitor: true}])
  .factory('APIInteractions', ['$resource', ($resource) -> $resource "api.php?path=/interactions.json", {}, {save: {method: 'POST', params: {_private: true}}}])
  
  
  
  .factory('APIFavoritesTable', ['Tablify', (Tablify) -> Tablify "api2.php"])
  .factory('APIFavorites',    ['$resource', ($resource) -> $resource "api2.php?shortcode=:shortcode", {shortcode: '@shortcode'}])
  
  .factory('APIReadTable',    ['Tablify',   (Tablify)   -> Tablify   "api3.php"])  
  .factory('APIRead',         ['$resource', ($resource) -> $resource "api3.php"])
 
  
 

  .factory('APIData',         ['$resource', ($resource) -> $resource "core/data/data-:slug.json", {slug: '@slug'}])
   
  .factory('APIStatistics',   ['$resource', ($resource) -> $resource "api.php?path=/statistics"])  


  .factory('APIScan',         ['$resource', ($resource) -> $resource "api.php?path=/:qrcode/scanning", {auth_token: '@auth_token', exhibitor_id: '@exhibitor_id', _scan: true}, {scan: {method: 'PUT'}}]) 


  .factory('APIRead2Table',   ['Tablify',   (Tablify)   -> Tablify   "api_read.php"])  
  .factory('APIRead2',        ['$resource', ($resource) -> $resource "api_read.php"])
  .factory('APIForm',         ['$resource', ($resource) -> $resource "api7.php"])

  .factory('APIPrograms',     ['$resource', ($resource) -> $resource "api.php?path=/schedule"])
  .factory('APISpeakers',     ['$resource', ($resource) -> $resource "api.php?path=/schedule/speakers/:id"])
  .factory('APISlots',        ['$resource', ($resource) -> $resource "api.php?path=/schedule/slots/:id", {id: '@id'}])